import { IconButton, colors, Typography } from '@sweep-io/sweep-design';
import { ChevronDown, ChevronUp } from '@sweep-io/sweep-design/dist/icons';
import { useState } from 'react';
import Collapse from '@mui/material/Collapse/Collapse';
import { PromptsBoxProps } from './promptsBoxTypes';
import { Box } from '@mui/material';
import { PromptWithArrow } from './PromptWithArrow';

export const PromptsBoxCollapsible = ({
  predefinedPrompts,
  onConfirm,
  disabled,
  header = 'Use AI Assistant to ask a question',
}: PromptsBoxProps) => {
  const [isCollapsed, setIsCollapsed] = useState(false); //product requested to be closed by default
  const [sentPromptKeys, setSentPromptKeys] = useState<string[]>([]);

  const promptKeysToRender = Object.keys(predefinedPrompts).filter(
    (key) => !sentPromptKeys.includes(key),
  );
  const isAllPromptsSent = Object.keys(predefinedPrompts).length === sentPromptKeys.length;

  return (
    <>
      <Box
        sx={{
          display: 'flex',
          justifyContent: 'space-between',
          pb: 1,
          alignItems: 'center',
        }}
      >
        <Typography color={colors.grey[800]} variant="h5-medium">
          {header}
        </Typography>
        <IconButton size="tiny" variant="system" onClick={() => setIsCollapsed((prev) => !prev)}>
          {isCollapsed ? <ChevronDown /> : <ChevronUp />}
        </IconButton>
      </Box>
      <Collapse in={isCollapsed}>
        <Box
          sx={{
            display: 'flex',
            flexDirection: 'column',
            gap: 1,
            pb: isAllPromptsSent ? 0 : 2,
          }}
        >
          {promptKeysToRender.map((key) => {
            const prompt = predefinedPrompts[key];
            return (
              <PromptWithArrow
                key={key}
                prompt={{
                  id: key,
                  name: prompt,
                  promptText: prompt,
                }}
                isDisabled={disabled}
                onClick={() => {
                  onConfirm(prompt);
                  setSentPromptKeys([...sentPromptKeys, key]);
                }}
              />
            );
          })}
        </Box>
      </Collapse>
    </>
  );
};
